import React from "react";
import * as S from "./AutoSuggest.styles";
import Icon from "../../../../core-components/IconsSelector";
interface ICard {
  title: string;
  subTitle: string;
  iconName?: string;
  IconNavigationCheck?: string;
}

const HomeAutoSuggestCard: React.FC<ICard> = ({
  title,
  subTitle,
  iconName = "",
  IconNavigationCheck = "",
}) => {
  return (
    <S.ListItem>
      {iconName ? (
        <Icon name={iconName} styleProps={{ width: "3rem", height: "3rem" }} />
      ) : null}
      <S.ListItemContent>
        <S.MainTxt>{title}</S.MainTxt>
        <S.SubTxt>{subTitle}</S.SubTxt>
      </S.ListItemContent>
      {IconNavigationCheck ? (
        <Icon
          name={IconNavigationCheck}
          styleProps={{ margin: "0rem 0rem 0rem 1.3rem" }}
        />
      ) : null}
    </S.ListItem>
  );
};
export default React.memo(HomeAutoSuggestCard);
